// extracted by mini-css-extract-plugin
export default {"newsDetails":"NewsDetails_newsDetails__Emppp","alert":"NewsDetails_alert__5KD6M"};